import React from 'react';
import PropTypes from 'prop-types';

export default function InsiderPlus(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={props.color || '#8E8E92'} {...props}>
      <path d="M286.5 229.8l52.3 0 0 56.7-52.3 0 0 52.3-56.7 0 0-52.3-52.3 0 0-56.7 52.3 0 0-52.3 56.7 0 0 52.3zm-60-207L22.9 226.6C7.6 241.8 6.7 265.9 20 282.3l.2 .2 .2 .2 2.1 2.3 .2 .2 203.9 203.9c16.2 16.2 42.6 16.2 58.8 0L489.1 285.4c16.2-16.2 16.2-42.6 0-58.8L285.4 22.9c-16.2-16.2-42.6-16.2-58.8 0zM67.4 256L256 67.4 444.6 256 256 444.6 67.4 256z" />
    </svg>
  );
}

InsiderPlus.propTypes = {
  color: PropTypes.string
};
